<div [ngClass]="theme()">
  <aw-toast></aw-toast>

  <aw-navigation-menu
    [options]="navigationOptions"
    [menuItems]="menuItems"
    [userInformation]="userInformation()"
    [applicationInformation]="applicationInformation"
    [sideDrawerExpansions]="sideDrawerExpansions()"
    [sessionTimerConfig]="sessionTimerConfig"
    ariaLabel="Left navigation menu"
  >
    <aw-top-navigation
      [options]="topNavOptions"
      [navigationOptions]="topNavSelectionOptions"
    ></aw-top-navigation>

    <router-outlet></router-outlet>
  </aw-navigation-menu>
</div>
